/**
 * @file Scrolls the page to the top whenever the route changes.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top each time the route's pathname changes,
 * and renders nothing.
 */
const ScrollToTop = (): null => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" as ScrollBehavior,
    });
  }, [ pathname ]);

  return null;
};

export default ScrollToTop;
